import React from "react";
import { DialogBox } from ".";
import { CheckOutlined, CloseOutlined, SmileOutlined } from "@ant-design/icons";
import CustomButton from "../Buttons/CustomButtons";

export const AcceptDialog = ({
  open,
  close,
  heading,
  subheading,
  success = false,
  okButton = false,
  okAndCancelButton = false,
  okButtonText = "",
  handleOk,
  cancelButtonText = "",
  handleCancel,
  failed = false,
  celebrate = false,
}) => {
  return (
    <DialogBox open={open} onCancel={close} width="50%" maxWidth="300px">
      <div className="flex flex-col items-center text-center my-5 px-4">
        {(success || failed || celebrate) && (
          <div className="bg-gray-200 p-4 rounded-full mb-6 mt-4">
            {success && (
              <CheckOutlined
                style={{
                  fontSize: 40,
                  color: "#06513D",
                }}
              />
            )}
            {failed && (
              <CloseOutlined
                style={{
                  fontSize: 40,
                  color: "#D93025",
                }}
              />
            )}
            {celebrate && (
              <SmileOutlined
                style={{
                  fontSize: 40,
                  color: "#F59E0B",
                }}
              />
            )}
          </div>
        )}

        <div className="mx-4">
          <h3 className="text-xl font-bold">{heading}</h3>
          <p className="text-[#000000] mt-2 text-sm">{subheading}</p>
        </div>

        {okButton && (
          <CustomButton
            buttonType="#06513D"
            variant="cancel"
            buttonText={okButtonText}
            className="text-sm px-6 py-2 rounded-lg"
            onClick={handleOk}
          />
        )}
        {okAndCancelButton && (
          <div className="flex justify-center gap-4 py-6">
            <CustomButton
              buttonType="#06513D"
              variant="cancel"
              buttonText={cancelButtonText}
              className="text-sm px-6 py-2 rounded-lg"
              onClick={handleCancel}
            />
            <CustomButton
              buttonType="#06513D"
              variant="ok"
              buttonText={okButtonText}
              className=" text-sm px-6 py-2 rounded-lg"
              onClick={handleOk}
            />
          </div>
        )}
      </div>
    </DialogBox>
  );
};
